import { createContext } from 'react';
import { CachedEntry } from './MobileOrderEntries';

export interface SelectionState {
  selectedIds: Set<string>;
  selectEntry: (entry: CachedEntry, allRootEntries: CachedEntry[]) => void;
  selectOnlyEntry: (entry: CachedEntry) => void;
  isSelected: (entryId: string) => boolean;
  isIndeterminate: (entry: CachedEntry) => boolean;
}

export const SelectedEntryContext = createContext<SelectionState>({
  selectedIds: new Set(),
  selectEntry: () => {
    // No-op for default context
  },
  selectOnlyEntry: () => {
    // No-op for default context
  },
  isSelected: () => false,
  isIndeterminate: () => false,
});
